import React, { useCallback, useState } from 'react'
import { Step_1 } from './views/Step_1'
import { Step_2 } from './views/Step_2'
import { Step_3 } from './views/Step_3'
import { Step_4 } from './views/Step_4'
import { Step_5 } from './views/Step_5'
import { Welcome } from './views/Welcome'

declare namespace dataLayer {
  function push(item: string | unknown): void
}

const setFormStackFieldValue = function (
  selector: string,
  value: string
): void {
  if (selector.length < 2) {
    throw new Error('Query selector string is invalid')
  }

  const field = document.querySelector(selector)

  if (
    field instanceof HTMLInputElement ||
    field instanceof HTMLTextAreaElement
  ) {
    field.value = value;
    
    const event = new Event('input', { bubbles: true });
    field.dispatchEvent(event);  
  }
} 

export const App = () => {
  const [activeState, setActiveState] = useState<number>(0)
  const [emailData, setEmail] = useState<string>('')
  const [materialData, setMaterial] = useState<string>('')
  const [designData, setDesign] = useState<string>('')

  const data = {
    email: emailData,
    material: materialData,
    design: designData
  }

  const nextStep = useCallback(
    function () {
      setActiveState(function (prevState) {
        return prevState + 1
      })
    },
    [setActiveState]
  )

  const GoOneStepBack = useCallback(
    function () {
      setActiveState(function (prevState) {
        return prevState - 1
      })
    },
    [setActiveState]
  )

  const goToDesign = useCallback(
    (email: string) => {
      setFormStackFieldValue('.fsFieldEmail[type=email]', email)

      setEmail(email)
      nextStep()
    },
    [nextStep]
  )

  const goToFinish = useCallback(
    (material: string, design: string) => {
      setFormStackFieldValue('#field165400613', material)
      setFormStackFieldValue('#field165400614', design)

      setMaterial(material)
      setDesign(design)
      nextStep()
    },
    [nextStep]
  )

  const goToDimension = useCallback(
    (activeMetal: string, activeWood: string, finish: string) => {
      setFormStackFieldValue('#field165400615', activeMetal)
      setFormStackFieldValue('#field165400616', activeWood)
      setFormStackFieldValue('#field165400617', finish)

      nextStep()
    },
    [nextStep]
  )

  const goToMounting = useCallback(
    (activeThickness: string, length: string, width: string, qty: string) => {
      setFormStackFieldValue('#field165400618', activeThickness)
      setFormStackFieldValue('#field165400619', length)
      setFormStackFieldValue('#field165400620', width)
      setFormStackFieldValue('#field165400625', qty)

      nextStep()
    },
    [nextStep]
  )

  const goToForm = useCallback(
    (mountingHoles: string, undersideLip: string) => {
      setFormStackFieldValue('#field165400621', mountingHoles)
      setFormStackFieldValue('#field165400622', undersideLip)

      nextStep()
    },
    [nextStep]
  )

  const goToEnd = useCallback(
    (
      firstName: string,
      lastName: string,
      phone: string,
      status: string,
      comment: string
    ) => {
      setFormStackFieldValue('#field165400626', firstName)
      setFormStackFieldValue('#field165400627', lastName)
      setFormStackFieldValue('#field165400628', phone)
      setFormStackFieldValue('#field165400629', status)
      setFormStackFieldValue('#field165400630', comment)

      const submitButton = document.querySelector('#fsForm5762058')

      const formData = {
        'first name': firstName,
        'last name': lastName,
        phone: phone,
        status: status,
        comment: comment
      }

      if (submitButton instanceof HTMLElement) {
        submitButton.submit()        
        dataLayer.push({
          event: 'Custom Sizes Sign-up',
          location: document.location.pathname,
          form: formData
        })
        console.log('formData', formData) 
      }
    },
    []
  )

  switch (activeState) {
    case 0:
      return <Welcome goNextStep={goToDesign} />
    case 1:
      return <Step_1 goNextStep={goToFinish} goBackStep={GoOneStepBack} />
    case 2:
      return (
        <Step_2
          approvedData={data}
          goNextStep={goToDimension}
          goBackStep={GoOneStepBack}
        />
      )
    case 3:
      return (
        <Step_3
          approvedData={data}
          goNextStep={goToMounting}
          goBackStep={GoOneStepBack}
        />
      )
    case 4:
      return <Step_4 goNextStep={goToForm} goBackStep={GoOneStepBack} />
    case 5:
      return <Step_5 goNextStep={goToEnd} goBackStep={GoOneStepBack} />
    default:
      return <Welcome goNextStep={goToDesign} />
  }
}
export default App
